import { Auth } from 'src/app/domain/models/auth.model';
import { Mapper } from '../base/mapper';
import { UserAttributesModel } from '../models/user-attributes.model';

export class UserAttributesMapper extends Mapper<UserAttributesModel, Auth> {
  mapFrom(userAttributes: UserAttributesModel): Auth {
    return {
      token: userAttributes['token'],
      idCommerce: Number(userAttributes['custom:idCommerce']),
      idFranchise: Number(userAttributes['custom:idFranchise']),
      idRole: Number(userAttributes['custom:idRole']),
      idBranch: userAttributes['custom:idBranch'],
      idPlan: userAttributes['custom:idPlan'],
      uidCms: userAttributes['custom:uidCms'],
      userName: userAttributes['custom:userName'],
      name: userAttributes['custom:name'],
      commerceName: userAttributes['custom:commerceName'],
      commerceType: userAttributes['custom:commerceType'],
      categoryName: userAttributes['custom:categoryName'],
      countryCode: userAttributes['custom:countryCode'],
      roleName: userAttributes['custom:roleName'],
      platform: userAttributes['custom:platform'],
      baseUrl: userAttributes['custom:baseUrl'],
      imageCommerceUrl: userAttributes['custom:imageCommerceUrl'],
    };
  }
}
